import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { useTranslation } from "react-i18next";
import ModalHeader from "../../../common/ModalHeader";
import ModalBody from "../../../common/ModalBody";
import ModalFooter from "../../../common/ModalFooter";
import Constants from "../../../../common/Constants";

const RevisingNumberForm = ({ data, show, onHide, onSave }) => {
  const [date, setDate] = useState("");
  const [reportType, setReportType] = useState("");
  const [reviseNumber, setReviseNumber] = useState("");
  const [remarks, setRemarks] = useState("");
  const [validated, setValidated] = useState(false);
  const formRef = useRef(null);
  const { t } = useTranslation();
  const isEdit = Boolean(data?._id);

  useEffect(() => {
    if (isEdit) {
      setDate(moment(data.date).format("YYYY-MM-DD"));
      setReportType(data.reportType || "");
      setReviseNumber(data.reviseNumber || "");
      setRemarks(data.remarks || "");
    }
  }, [data, isEdit]);

  const handleSave = () => {
    const form = formRef.current;
    if (!form?.checkValidity()) {
      setValidated(true);
      return;
    }

    onSave(
      {
        ...(isEdit ? { _id: data._id } : {}),
        date,
        reportType,
        reviseNumber: reviseNumber.trim(),
        remarks: remarks.trim(),
      },
      isEdit
    );
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} backdrop="static">
      <ModalHeader
        title={t(
          isEdit
            ? "msg_master_list.msg_revising_number.edit_title"
            : "msg_master_list.msg_revising_number.add_title"
        )}
      />
      <ModalBody>
        <Form noValidate validated={validated} ref={formRef}>
          <Form.Group className="mb-3">
            <Form.Label>Type of Report :</Form.Label>
            <Form.Select
              value={reportType}
              onChange={(event) => setReportType(event.target.value)}
              required
              autoFocus
            >
              <option value="">Select Type of Report</option>
              {Constants.MASTER.REVISING_NUMBER.REPORT_TYPES.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Type of Report is required.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {t("msg_master_list.msg_revising_number.date")} :
            </Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(event) => setDate(event.target.value)}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_revising_number.date_required")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {t("msg_master_list.msg_revising_number.revise_number")} :
            </Form.Label>
            <Form.Control
              type="text"
              value={reviseNumber}
              onChange={(event) => setReviseNumber(event.target.value)}
              maxLength={100}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_revising_number.revise_number_required")}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              {t("msg_master_list.msg_revising_number.remarks")} :
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={remarks}
              onChange={(event) => setRemarks(event.target.value)}
              maxLength={1000}
              required
            />
            <Form.Control.Feedback type="invalid">
              {t("msg_master_list.msg_revising_number.remarks_required")}
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button variant="success" onClick={handleSave}>
          {t("msg_common.save")}
        </Button>
        <Button variant="danger" onClick={onHide}>
          {t("msg_common.cancel")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RevisingNumberForm;
